/**
 * The honest boundary for a link target that has no surface yet.
 *
 * A recovered component defaults some link to a path the 18 recovered screens do not cover. Rather
 * than invent a screen, redirect somewhere unrelated or show a bare 404, the shell says exactly what
 * is missing and which delivery task owns it. The gap stays visible in the running application.
 */
import React from 'react';

export default function RouteNotBuilt({ label, reason, ownedBy, path }) {
  return (
    <main data-route-state="not-built" style={{ padding: '2rem', maxWidth: '42rem' }}>
      <h1>{label} is not built yet</h1>
      <p>{reason}</p>
      <p>
        Delivery task: <strong>{ownedBy}</strong>. Route: <code>#{path}</code>.
      </p>
      <p>
        <a href="#/today">Back to Today</a>
      </p>
    </main>
  );
}
